import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_WORKFLOW_ID } from 'routes/libra/-searchParams'
import { Route as NewRoute } from 'routes/libra/index'

export const Route = createFileRoute(
  '/libra/(deprecated_routes)/$orgID/{-$workflowId}'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_ORG_ID]: params.orgID,
        [SEARCH_PARAM_WORKFLOW_ID]: params.workflowId,
      }),
      replace: true,
    })
  },
})
